import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconRadioOff = SvgIcon({
    children: jsxs(Fragment, { children: [jsx("circle", { cx: "12", cy: "12", r: "10", fill: "transparent" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z" })] }),
});

export { IconRadioOff };
